import { tracked } from '@glimmer/tracking';

import { MetricLibrarySortBy } from 'webapp/enums/enums';
import { TrackingEvent } from 'webapp/enums/tracking';
import type { SearchProps } from 'webapp/utils/filter';
import { AdvancedSortProps } from 'webapp/utils/metric-sort';

import type { Metric } from 'webapp/models-custom';
import type { FilterSortSettings } from 'webapp/models-custom/filter-sort/base';
import FilterSort from 'webapp/models-custom/filter-sort/base';

export default class FilterSortMetricLibrarySourceMetrics extends FilterSort<Metric> {
	@tracked override sortProp = AdvancedSortProps.prop;
	@tracked override sortOrder = AdvancedSortProps.direction;

	override itemDomSelector = 'li.filter-sort-item';

	override searchProps: SearchProps = {
		name: 2,
		description: 1,
	};

	override typedFilterEventName = TrackingEvent.METRIC_SEARCH;
	override trackingObjectName = 'metric';

	constructor(options: FilterSortSettings<Metric>, searchPlaceholder?: string) {
		super(options);

		if (searchPlaceholder) {
			this.searchPlaceholder = searchPlaceholder;
		}

		const selectedFilters = this.readSavedSelectedFilters();
		if (selectedFilters[1]) {
			const selected = selectedFilters[1][0] as MetricLibrarySortBy;
			this.onSortFilterChange(selected);
		}

		this.createFilter({
			id: 1,
			label: 'Sort by',
			name: 'sort',
			selected: selectedFilters[1],
			stringValues: true,
			isSort: true,
			getOptions: () => {
				return this.sortByOptions;
			},
			onSelectedChange: (filter) => {
				const selected = filter.selected[0] as MetricLibrarySortBy;
				this.onSortFilterChange(selected);
			},
		});
	}

	get sortByOptions() {
		return Object.values(MetricLibrarySortBy).map((sort) => ({
			id: sort,
			text: sort,
		}));
	}

	override get isAnyFilterActive(): boolean {
		return this.filters.some((f) => (f.isSort ? false : f.isActive));
	}

	override resetFilters(): void {
		this.filters.forEach((f) => {
			if (f.isSort) {
				f.selectOption(f.options[0]!.id);
			} else {
				f.selectOption(f.defaultValue);
			}
		});
	}

	override updateSortBy(sortBy: MetricLibrarySortBy): void {
		switch (sortBy) {
			default:
			case MetricLibrarySortBy.POPULARITY:
				this.sortProp = AdvancedSortProps.prop;
				break;
			case MetricLibrarySortBy.ALPHABETICALLY: {
				this.sortProp = 'name';
				break;
			}
		}
	}
}
